var path = 'src/app/account/account.html';
var html = "<div page-wrapper> <h1 class=page-header>Account</h1> <div account-component user=user></div> <h2 class=page-header>Change Email</h2> <div change-email-component user=user></div> <h2 class=page-header>Change Password</h2> <div change-password-component user=user></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/account/account.html
 ** module id = 19
 ** module chunks = 0
 **/